<template>
  <section class="closing" id="start">
    <div class="wrap">
     <div class="card-red">
      <div>
        <h2>The revenue is waiting.</h2>
        <p>Connect your screens and start selling.</p>
      </div>
      <div class="cta-row">
        <a class="btn btn-white" href="#/home" data-auth="register">Get Adverpost</a>
        <a class="btn btn-ghost" href="#demo" data-demo>Book a demo</a>
      </div>
     </div>
    </div>
  </section>
</template>

<script> 
// Extracted from the published landing page; in-page anchors emit instead of
// navigating, because the app uses a hash router.
export default { name: "ClosingSection" };
</script>
